import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { homeBreadcrumbItem, useBreadcrumbsService } from 'shared/UI/UIKit/Breadcrumbs';
import { getBuildingsUrl } from 'services/navigation';
import { getBuildingById } from 'services/api';
import type { Building } from 'services/api';
import type { BuildingPageParams } from 'services/navigation';

const getBuildingBreadcrumbs = (buildingName: string) => {
  return [
    homeBreadcrumbItem,
    {
      title: 'Здания',
      url: getBuildingsUrl(),
    },
    {
      title: buildingName,
      url: '',
    },
  ];
};

export const useBuildingPage = () => {
  const { buildingId } = useParams<BuildingPageParams>();
  const breadcrumbsService = useBreadcrumbsService();
  const [building, setBuilding] = useState<Building | null>(null);

  useEffect(() => {
    if (buildingId) {
      breadcrumbsService.setBreadcrumbsLoading(true);

      getBuildingById(Number(buildingId))
        .then((res) => {
          breadcrumbsService.setBreadcrumbs(getBuildingBreadcrumbs(res.name));
          setBuilding(res);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          breadcrumbsService.setBreadcrumbsLoading(false);
        });
    }
  }, [buildingId]);

  return {
    breadcrumbs: breadcrumbsService.breadcrumbs,
    breadcrumbsLoading: breadcrumbsService.breadcrumbsLoading,
    building,
  };
};
